(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.countdown = {
        attach: function (context, settings) {
            once('countdown', '[data-countdown]', context).forEach(function (element) {
                const timestamp = parseInt(element.getAttribute('data-countdown'), 10);

                if (!timestamp) return;

                const targetDate = new Date(timestamp * 1000);
                
                // Add class to indicate countdown is initializing
                element.classList.add('countdown--initializing');

                const days1El = element.querySelector('[data-unit="days-1"]');
                const days2El = element.querySelector('[data-unit="days-2"]');
                const hours1El = element.querySelector('[data-unit="hours-1"]');
                const hours2El = element.querySelector('[data-unit="hours-2"]');
                const minutes1El = element.querySelector('[data-unit="minutes-1"]');
                const minutes2El = element.querySelector('[data-unit="minutes-2"]');
                const seconds1El = element.querySelector('[data-unit="seconds-1"]');
                const seconds2El = element.querySelector('[data-unit="seconds-2"]');

                let prevDays1 = null;
                let prevDays2 = null;
                let prevHours1 = null;
                let prevHours2 = null;
                let prevMinutes1 = null;
                let prevMinutes2 = null;
                let prevSeconds1 = null;
                let prevSeconds2 = null;

                // Only reload when the countdown reaches zero *during* this page view.
                // If the timer is already in the past on load, do not reload (avoids endless reload loop).
                let hadPositiveDistance = false;

                const updateCountdown = () => {
                    const now = new Date().getTime();
                    const distance = targetDate - now;

                    if (distance > 0) {
                        hadPositiveDistance = true;
                    }

                    // If the countdown passed, clamp distance to 0 to avoid negative values
                    const clampedDistance = Math.max(0, distance);

                    const days = Math.floor(clampedDistance / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((clampedDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((clampedDistance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((clampedDistance % (1000 * 60)) / 1000);

                    const daysStr = String(days).padStart(2, '0');
                    const days1 = daysStr[0];
                    const days2 = daysStr[1];

                    if (days1 !== prevDays1) {
                        days1El.textContent = days1;
                        prevDays1 = days1;
                    }

                    if (days2 !== prevDays2) {
                        days2El.textContent = days2;
                        prevDays2 = days2;
                    }

                    const hoursStr = String(hours).padStart(2, '0');
                    const hours1 = hoursStr[0];
                    const hours2 = hoursStr[1];

                    if (hours1 !== prevHours1) {
                        hours1El.textContent = hours1;
                        prevHours1 = hours1;
                    }

                    if (hours2 !== prevHours2) {
                        hours2El.textContent = hours2;
                        prevHours2 = hours2;
                    }

                    const minutesStr = String(minutes).padStart(2, '0');
                    const minutes1 = minutesStr[0];
                    const minutes2 = minutesStr[1];

                    if (minutes1 !== prevMinutes1) {
                        minutes1El.textContent = minutes1;
                        prevMinutes1 = minutes1;
                    }

                    if (minutes2 !== prevMinutes2) {
                        minutes2El.textContent = minutes2;
                        prevMinutes2 = minutes2;
                    }

                    const secondsStr = String(seconds).padStart(2, '0');
                    const seconds1 = secondsStr[0];
                    const seconds2 = secondsStr[1];

                    if (seconds1 !== prevSeconds1) {
                        seconds1El.textContent = seconds1;
                        prevSeconds1 = seconds1;
                    }

                    if (seconds2 !== prevSeconds2) {
                        seconds2El.textContent = seconds2;
                        prevSeconds2 = seconds2;
                    }

                    // When we've reached zero: stop the interval and only reload if we had been counting down.
                    // If the timer was already in the past on page load, just show 00:00:00:00 and do not reload.
                    if (distance <= 0) {
                        if (element.countdownInterval) {
                            clearInterval(element.countdownInterval);
                            element.countdownInterval = null;
                        }
                        if (hadPositiveDistance) {
                            location.reload();
                        }
                    }
                };

                updateCountdown();
                // Remove initializing class after first update
                element.classList.remove('countdown--initializing');
                const interval = setInterval(updateCountdown, 1000);

                element.countdownInterval = interval;
            });
        },

        detach: function (context, settings, trigger) {
            if (trigger === 'unload') {
                once.remove('countdown', '[data-countdown]', context).forEach(function (element) {
                    if (element.countdownInterval) {
                        clearInterval(element.countdownInterval);
                    }
                });
            }
        }
    };

})(Drupal, once);
